import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Header from "../../components/layouts/Header/OverviewHeader";
import Footer from "../../components/layouts/Footer/OverviewFooter";
import Welcome from "../../components/ui-elements/Welcome/Welcome";
import * as styles from "./overviewStyles";
import { Card, CardContent, CardMedia } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import { POSTERS } from "../../constants/poster-constants";

const Overview = () => {
    return (
        <Box sx={styles.homeContainer}>
            <Header />
            <Box sx={styles.welcomeSection}>
                <Welcome />
            </Box>
            <Grid container sx={styles.answersGrid}>
                {POSTERS.filter((p) => p.overviewImageUrl).map((p) => (
                    <Grid item key={p.route} sx={styles.grid}>
                        <Card component={Link} to={p.route} sx={styles.card}>
                            <CardMedia
                                component="img"
                                image={p.overviewImageUrl}
                                alt={p.title}
                                sx={styles.cardMedia}
                            />
                            <Box sx={styles.arrowIcon}>
                                <ArrowForwardIcon sx={styles.arrowIconSvg} />
                            </Box>
                            <CardContent sx={styles.cardContent}>
                                <Box
                                    component="img"
                                    src="/images/illustrations/1887.png"
                                    alt="1887"
                                    sx={styles.logoImage}
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            <Footer />
        </Box>
    );
};

export default Overview;
